import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const callApi = createApi({
    reducerPath: 'callApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'api',
        prepareHeaders: (headers, { getState }) => {
            const token = getState().token.value;
            if (token) {
                headers.set("Authorization", `Bearer ${token.Token}`);
            }
            return headers;
        },
    }),
    keepUnusedDataFor: 0,
    // global configuration for the api
    refetchOnMountOrArgChange: 0,
    tagTypes: ['User', 'Clients'],
    endpoints: (builder) => ({
        refreshToken: builder.mutation({
            query: (refTokrn) => ({
                url: '/api/login/refreshtoken',
                method: `POST`,
                body: refTokrn
            })
        }),
        checkToken: builder.query({
            query: () => 'users/checktoken'
        }),
        getUsers: builder.query({
            query: ({ pageIndex, pageSize, stringFilter }) => `users/getusers?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`,

            // query: ({pageIndex, pageSize, stringFilter}) => `users/getusers?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`,
        }),
        addUser: builder.query({
            query: () => ({
                url: 'adduser',
                method: 'POST',
                body: {},
            })
        }),
        getUserById: builder.query({
            query: (user_id) => `users/${user_id}`,
        }),
        getClientsByPhone: builder.mutation({
            query: (phone) => `clients/phone?phone=${phone}`,
        }),
        getUserRole: builder.query({
            query: () => `users/GetRoleList`
        }),
        putUserById: builder.mutation({
            query: ({ id, ...form }) => ({
                url: `users/${id}`,
                method: 'PUT',
                body: form,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                providesTags: ['User']
            }),

        }),
        chengePasswordUser: builder.mutation({
            query: (data) => (
                {
                    url: `users/chengePassword`,
                    method: `PUT`,
                    body: data,
                })
        }),
        addClientFromToble: builder.mutation({
            query: ({ ...form }) => ({
                url: `clients/addclientfromtable`,
                method: 'POST',
                body: form,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),

        }),
        getCertOrders: builder.query({
            query: ({ pageIndex, pageSize, stringFilter }) => `certificateorders/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`
        }),
        getCertOrderDetails: builder.query({ query: ({ id }) => `certificateorders/${id}` }),
        resendCertOrder: builder.mutation({ query: ({ id }) => `certificateorders/resend/${id}` }),
        getOrders: builder.query({
            query: ({ pageIndex, pageSize, stringFilter }) => `orders/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`
        }),
        getOrder: builder.query({ query: (id) => `orders/${id}` }),
        payOrder: builder.mutation({
            query: ({ ...body }) => ({
                url: `orders/payorder/${body.id}?PaymentsTypeData=${body.paymentsTypeData}&elctReceipt=${body.elctReceipt}`,
                method: `GET`,
            })
        }),
        cancelOrder: builder.mutation({
            query: (id) => ({
                url: `orders/${id}/cancel`,
                method: `GET`,
            })
        }),
        getCategories: builder.query({ query: () => `categories` }),
        getCategorie: builder.query({ query: (id) => `categories/${id}` }),
        putCategorie: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `categories/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            })
        }),
        getAgents: builder.query({ query: () => `agents` }),
        getAgent: builder.query({ query: (id) => `agents/${id}` }),
        getProducts: builder.query({
            query: ({ pageIndex, pageSize, stringFilter }) => `products/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`
        }),
        getProductParams: builder.query({ query: () => `products/product-prams` }),
        addProduct: builder.mutation(
            {
                query: ({ ...form }) => ({
                    url: `products`,
                    method: `POST`,
                    body: form,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                })
            }
        ),
        getProduct: builder.query({ query: (id) => `products/${id}` }),
        putProduct: builder.mutation(
            {
                query: ({ ...form }) => ({
                    url: `products/${form.id}`,
                    method: `PUT`,
                    body: form,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                })
            }
        ),
        postProductPhoto: builder.mutation(
            {
                query: ({ id, ...form }) => ({
                    url: `products/photo/${id}`,
                    method: `POST`,
                    body: form,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                })
            }
        ),
        deleteProductPhoto: builder.mutation(
            {
                query: (id) => ({
                    url: `products/deletephoto/${id}`,
                    method: `PUT`
                })
            }
        ),
        getCatalogProducts: builder.query({ query: () => `products/catalog/` }),
        createOrder: builder.mutation({
            query: (body) => ({
                url: `orders`,
                method: `POST`,
                body: body
            })
        }),
        getAgreementOrder: builder.mutation({
            query: (id) => ({
                url: `orders/agreement/${id}`,
                method: `GET`,
            })
        }),
        getClients: builder.query({ query: ({ pageIndex, pageSize, stringFilter }) => `clients/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}`, providesTags: ['Clients'] }),
        getClientById: builder.query({ query: (id) => `clients/${id}`, providesTags: ['Clients'] }),
        putClient: builder.mutation({
            query: ({ ...body }) => ({
                url: `clients/${body.id}`,
                method: "PUT",
                body: body
            }), invalidatesTags: ["Clients"]
        }),
        getEventType: builder.query({ query: () => `sessionevents/geteventtype` }),
        addSessionEvent: builder.mutation({
            query: (body) => ({
                url: `sessionevents`,
                method: 'POST',
                body: body
            })
        }),
        getSessionEvents: builder.query({ query: ({ pageIndex, pageSize, stringFilter }) => `sessionevents/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}` }),
        getSessionEventDetails: builder.query({ query: (id) => `sessionevents/${id}` }),
        putSessionEventIsHide: builder.mutation({
            query: (id) => ({
                url: `sessionevents/set-hide/${id}`,
                method: 'PUT'
            })
        }),
        postVisitorList: builder.mutation({
            query: ({ body }) => ({
                url: `sessionevents/importlist`,
                method: `POST`,
                body: body,
                headers: {
                    "Content-Type": "multipart/form-data;"
                }
            })
        }),
        getVisitorList: builder.query({ query: ({ id, stringFilter }) => `sessionevents/getvisitorlist/${id}` }),
        getVisitor: builder.query({ query: (id) => `sessionevents/visitor/${id}` }),
        getReportIgora: builder.query({ query: ({ startDate, endDate }) => `reportsservice/getitemorderigora/?startDate=${startDate}&endDate=${endDate}` }),
        getReportNikolas: builder.query({ query: ({ startDate, endDate }) => `reportsservice/nikalasreportorders/?startDate=${startDate}&endDate=${endDate}` }),
        getInternetOrders: builder.query({ query: (data) => `reportsservice/get-internet-orders?selEvenDate=${data}` }),
        getShows: builder.query({ query: () => `shows` }),
        createCorporateRequest: builder.mutation({
            query: ({ ...body }) => ({
                url: `requests/corporate`,
                method: `POST`,
                body: body,
            })
        }),
        createRentRequest: builder.mutation({
            query: ({ ...body }) => ({
                url: `requests/rent`,
                method: `POST`,
                body: body,
            })
        }),
        findOfBarcode: builder.mutation({ query: (barcode) => `sessionevents/barcode/${barcode}` }),
        getBarcodeList: builder.query({ query: (id) => `sessionevents/barcodelist/${id}` }),
        getStatusCasting: builder.query({ query: () => 'worksheets' }),
        getTicketsOrders: builder.query({ query: ({ pageIndex, pageSize, stringFilter, showAll }) => `ticketsorders/?pageIndex=${pageIndex}&pageSize=${pageSize}&stringFilter=${stringFilter}${showAll ? "&showAll=true" : ""}` }),
        getTicketsOrderDitails: builder.query({ query: (id) => `ticketsorders/${id}` }),
        getRefundTicketsOrder: builder.mutation({ query: (id) => `ticketsorders/refund/${id}` }),
        getResendTickets: builder.mutation({ query: (id) => `ticketsorders/resend-tickets/${id}` }),
        postWorksheet: builder.mutation({ query: (body) => ({ url: `worksheets?sendTo=cast@leningradcenter.ru`, body: body, method: 'POST' }) }),
    }),

}

)

export const {
    useRefreshTokenMutation,
    useGetUsersQuery,
    useCheckTokenQuery,
    useGetUserByIdQuery,
    useGetUserRoleQuery,
    usePutUserByIdMutation,
    useAddClientFromTobleMutation,
    useChengePasswordUserMutation,
    usePostWorksheetMutation,
    useGetCertOrdersQuery,
    useGetCertOrderDetailsQuery,
    useGetOrdersQuery,
    useGetOrderQuery,
    useGetCategoriesQuery,
    useGetCategorieQuery,
    usePutCategorieMutation,
    useGetAgentsQuery,
    useGetAgentQuery,
    useGetProductsQuery,
    useGetProductParamsQuery,
    useAddProductMutation,
    useGetProductQuery,
    usePutProductMutation,
    usePostProductPhotoMutation,
    useDeleteProductPhotoMutation,
    useGetCatalogProductsQuery,
    useGetClientsByPhoneMutation,
    useCreateOrderMutation,
    useGetAgreementOrderMutation,
    useCancelOrderMutation,
    usePayOrderMutation,
    useGetClientsQuery,
    useGetClientByIdQuery,
    usePutClientMutation,
    useGetEventTypeQuery,
    useAddSessionEventMutation,
    useGetSessionEventsQuery,
    useGetSessionEventDetailsQuery,
    usePutSessionEventIsHideMutation,
    usePostVisitorListMutation,
    useGetVisitorListQuery,
    useGetVisitorQuery,
    useGetReportIgoraQuery,
    useGetShowsQuery,
    useCreateCorporateRequestMutation,
    useCreateRentRequestMutation,
    useFindOfBarcodeMutation,
    useGetBarcodeListQuery,
    useResendCertOrderMutation,
    useGetReportNikolasQuery,
    useGetStatusCastingQuery,
    useGetTicketsOrdersQuery,
    useGetTicketsOrderDitailsQuery,
    useGetRefundTicketsOrderMutation,
    useGetResendTicketsMutation,
    useGetInternetOrdersQuery,
} = callApi